<template>
    <button class="return-btn" id="back_button" @click="goBack">
        <v-icon left>mdi-arrow-left-bold</v-icon>
        Volver
    </button>
</template>

<script>
export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped>
#back_button {
    position: sticky;
    font-family: var(--font-body);
    /* top: 0; */
    z-index: 1000;
    padding-right: 10px;
}
</style>
